'use strict';exports.__esModule = true;exports.toggleDescriptionTranslation = exports.detectDescriptionLanguage = exports.translateDescription = exports.loadCompanyProps = exports.resetTranslate = exports.loadStaff = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);
var _services = require('../../services');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var USER_STAFF_URL = 'users/staff/';

var loadStaff = (0, _reduxAct.createAction)('/LOAD_STAFF');
var loadStaffSuccess = (0, _reduxAct.createAction)('/LOAD_STAFF_SUCCESS');
var loadStaffFail = (0, _reduxAct.createAction)('/LOAD_STAFF_FAIL');

var detectDescriptionLanguage = (0, _reduxAct.createAction)('/DETECT_DESCRIPTION_LANGUAGE');
var detectDescriptionLanguageSuccess = (0, _reduxAct.createAction)('/DETECT_DESCRIPTION_LANGUAGE_SUCCESS');

var translateDescription = (0, _reduxAct.createAction)('/TRANSLATE_DESCRIPTION');
var translateDescriptionSuccess = (0, _reduxAct.createAction)('/TRANSLATE_DESCRIPTION_SUCCESS');
var translateDescriptionFail = (0, _reduxAct.createAction)('/TRANSLATE_DESCRIPTION_FAIL');

var toggleDescriptionTranslation = (0, _reduxAct.createAction)('/TOGGLE_DESCRIPTION_TRANSLATION');

var loadCompanyProps = (0, _reduxAct.createAction)('/LOAD_COMPANY_PROPS');
var loadCompanyPropsSuccess = (0, _reduxAct.createAction)('/LOAD_COMPANY_PROPS_SUCCESS');
var loadCompanyPropsFail = (0, _reduxAct.createAction)('/LOAD_COMPANY_PROPS_FAIL');

var resetTranslate = (0, _reduxAct.createAction)('/RESET_TRANSLATION');

var initialState = {
  data: null,
  properties: null,
  loaded: false,
  loading: false,
  propertiesLoaded: false,
  propertiesLoading: false,
  error: null,
  propertiesError: null,
  descriptionLoaded: false,
  showOriginalDescription: false,
  targetDescriptionLanguage: null,
  sourceDescriptionLanguage: null,
  translatedDescriptionRequired: null,
  translatedDescriptionText: null };


var setPropertyOption = function setPropertyOption(properties, optionType) {return properties.map(function (property) {
    property.option_type = optionType;
    return property;
  });};

var fetchLoad = function fetchLoad(id) {return _axios2.default.get('' + USER_STAFF_URL + id).
  then(loadStaffSuccess, loadStaffFail);};

var handleLoad = function handleLoad(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true }),
  promise(fetchLoad, action));};

var handleLoadSuccess = function handleLoadSuccess(state, _ref) {var data = _ref.data;return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: data });};


var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading realtor');
  error.status = response.response.status;

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var detectDescriptionCall = function detectDescriptionCall(_ref2) {var q = _ref2.q,locale = _ref2.locale;return _services.TranslationService.
  suggestStringLanguage(q, 0.7).
  then(function (detection) {
    if (detection) {
      return {
        targetDescriptionLanguage: locale,
        sourceDescriptionLanguage: detection.language,
        translatedDescriptionRequired: detection.language !== locale };

    }

    return { translatedDescriptionRequired: false };
  }).
  then(detectDescriptionLanguageSuccess);};

var handleDetectDescriptionLanguage = function handleDetectDescriptionLanguage(state, action) {
  if (!action.q || !action.q.length) {
    return Object.assign({},
    state, {
      translatedDescriptionRequired: false,
      descriptionLoaded: false,
      translatedDescriptionText: null,
      showOriginalDescription: false });

  }

  return (0, _reduxLoop.loop)(state, promise(detectDescriptionCall, action));
};

var handleToggleDescriptionTranslation = function handleToggleDescriptionTranslation(state) {return Object.assign({},
  state, {
    showOriginalDescription: !state.showOriginalDescription });};


var handleDetectDescriptionLanguageSuccess = function handleDetectDescriptionLanguageSuccess(state, action) {return Object.assign({},
  state,
  action);};


var fetchCompanyProps = function fetchCompanyProps(id) {return Promise.all([
  _axios2.default.get('properties/search?staff_id=' + id + '&option=buy'),
  _axios2.default.get('properties/search?staff_id=' + id + '&option=rent'),
  _axios2.default.get('properties/search?staff_id=' + id + '&option=rent-short')]).

  then(function (response) {var
    dataForSell = response[0].data,dataForRent = response[1].data,dataForShortRent = response[2].data;
    return [].concat(
    setPropertyOption(dataForSell.data, 'buy'),
    setPropertyOption(dataForRent.data, 'rent'),
    setPropertyOption(dataForShortRent.data, 'rent-short'));

  }).
  then(loadCompanyPropsSuccess).
  catch(loadCompanyPropsFail);};

var handleLoadCompanyProps = function handleLoadCompanyProps(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    propertiesLoading: true }),
  promise(fetchCompanyProps, action));};

var handleLoadCompanyPropsSuccess = function handleLoadCompanyPropsSuccess(state, action) {return Object.assign({},
  state, {
    propertiesLoaded: true,
    propertiesLoading: false,
    propertiesError: null,
    properties: action });};


var handleLoadCompanyPropsFail = function handleLoadCompanyPropsFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Failed to get company propertiess');
  return Object.assign({},
  state, {
    propertiesLoaded: false,
    propertiesLoading: false,
    propertiesError: error });

};

var translateDescriptionCall = function translateDescriptionCall(_ref3) {var q = _ref3.q,targetDescriptionLanguage = _ref3.targetDescriptionLanguage,sourceDescriptionLanguage = _ref3.sourceDescriptionLanguage;return _services.TranslationService.
  translate(q, targetDescriptionLanguage, sourceDescriptionLanguage).
  then(translateDescriptionSuccess).
  catch(translateDescriptionFail);};

var handleTranslateDescription = function handleTranslateDescription(state, _ref4) {var q = _ref4.q;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    descriptionLoading: true }),
  promise(translateDescriptionCall, {
    q: q,
    targetDescriptionLanguage: state.targetDescriptionLanguage,
    sourceDescriptionLanguage: state.sourceDescriptionLanguage }));};


var handleTranslateDescriptionSuccess = function handleTranslateDescriptionSuccess(state, action) {return Object.assign({},
  state, {
    translatedDescriptionText: action,
    descriptionLoading: false,
    descriptionLoaded: true });};


var handleTranslateDescriptionFail = function handleTranslateDescriptionFail(state) {return Object.assign({},
  state, {
    translatedDescriptionRequired: false,
    descriptionLoaded: false,
    translatedDescriptionText: null,
    showOriginalDescription: false });};


var handleResetTranslate = function handleResetTranslate(state) {return Object.assign({},
  state, {
    translatedDescriptionRequired: null,
    descriptionLoaded: false,
    showOriginalDescription: false,
    translatedDescriptionText: null,
    targetDescriptionLanguage: null,
    sourceDescriptionLanguage: null,
    translatedAdditionalInfoRequired: null,
    additionalInfoLoaded: false,
    showOriginalAdditionalInfo: false,
    translatedAdditionalInfoText: null,
    targetAdditionalInfoLanguage: null,
    sourceAdditionalInfoLanguage: null });};


var staff = (0, _reduxAct.createReducer)(function (on) {
  on(loadStaff, handleLoad);
  on(loadStaffSuccess, handleLoadSuccess);
  on(loadStaffFail, handleLoadFail);

  on(detectDescriptionLanguage, handleDetectDescriptionLanguage);
  on(detectDescriptionLanguageSuccess, handleDetectDescriptionLanguageSuccess);

  on(toggleDescriptionTranslation, handleToggleDescriptionTranslation);

  on(translateDescription, handleTranslateDescription);
  on(translateDescriptionSuccess, handleTranslateDescriptionSuccess);
  on(translateDescriptionFail, handleTranslateDescriptionFail);

  on(loadCompanyProps, handleLoadCompanyProps);
  on(loadCompanyPropsSuccess, handleLoadCompanyPropsSuccess);
  on(loadCompanyPropsFail, handleLoadCompanyPropsFail);

  on(resetTranslate, handleResetTranslate);
}, initialState);exports.


loadStaff = loadStaff;exports.
resetTranslate = resetTranslate;exports.
loadCompanyProps = loadCompanyProps;exports.
translateDescription = translateDescription;exports.
detectDescriptionLanguage = detectDescriptionLanguage;exports.
toggleDescriptionTranslation = toggleDescriptionTranslation;exports.default =


staff;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/staff.js
// module id = 1269
// module chunks = 0